import { WorkflowTasks } from '../WorkflowTasks';
import { TaskStatus } from '../TaskStatus';

export const createUpdatedCompletionDataFromMap = (existingCompletionData, map, hasUploadedFiles) => {
    var completionData = existingCompletionData ? { ...existingCompletionData } : {}

    if (map) {
        var additionalDocs = {};

        Object.keys(map).filter(f => Boolean(map[f])).forEach(k => {
            additionalDocs[k] = {
                fileId: null,
                version: null
            }
        });

        completionData.additionalDocuments = additionalDocs;
    }

    completionData.hasUploadedFiles = hasUploadedFiles
    return completionData;
}

export const createInProgressTaskCompletionObject = (completion, documentMap, hasUploadedFiles) => {
    var existingCompletionData = {};

    if (completion) {
        existingCompletionData = completion.completionData ? JSON.parse(completion.completionData) : {};
    }

    var completionData = createUpdatedCompletionDataFromMap(existingCompletionData, documentMap, hasUploadedFiles);

    return {
        workflowTask: WorkflowTasks.RETURN_PREPARED,
        status: TaskStatus.IN_PROGRESS,
        completionData: JSON.stringify(completionData)
    }
}


export const createPrepareCompleteRequestPayload = (primaryPomEligible, spousePomEligible) => {
    return {
        PrimaryPomEligible: primaryPomEligible === 'yes' ? true : false,
        SpousePomEligible: spousePomEligible === 'yes' ? true : false
    }
}


